import { Button, Input, message } from "antd";
import { useContext, useState } from "react";
import "../../components/design/CreateFolderModal.scss";
import DSAApi from "../../api/DSAApi";
import { DsaUploadFolderDto } from "../../generated/dashboard-client";
import { AppContext } from "../../AppContext";
import FolderIcon from "../icons/FolderIcon";

export interface DsaCreateFolderContentProps {
  uploadIds: string[];
  onClose: (uploadIds: string[], folderToMove?: DsaUploadFolderDto | null, folder?: DsaUploadFolderDto, parentFolder?: DsaUploadFolderDto | null) => void;
  folderToMove: DsaUploadFolderDto | null;
  parentFolder: DsaUploadFolderDto | null;
  folderNameExists: (folder: DsaUploadFolderDto | null, name: string) => boolean | undefined;
}

export function DsaCreateFolderContent({
  uploadIds,
  onClose,
  folderToMove,
  parentFolder,
  folderNameExists
}: DsaCreateFolderContentProps) {
  const [name, setName] = useState("");
  const [saving, setSaving] = useState(false);
  const { location } = useContext(AppContext);

  async function save() {
    setSaving(true);

    if (folderNameExists(null, name)) {
      setSaving(false);
      return;
    }

    try {
      const { data } = await DSAApi.createLocationFolder(location.internalId!, name);

      if (folderToMove) {
        await DSAApi.putFolderInFolder(folderToMove.id!, data.id!);
      } else if (uploadIds.length > 0) {
        await DSAApi.putUploadsInFolder(uploadIds, data.id!);
      }

      if (parentFolder) {
        await DSAApi.putFolderInFolder(data.id!, parentFolder.id!);
      }

      setSaving(false);
      message.success("Folder created");
      onClose(uploadIds, folderToMove, data, parentFolder);
    } catch (err) {
      setSaving(false);
    }
  }

  return (
    <div>
      <header>
        <FolderIcon />
        <h2>Create New Folder</h2>
      </header>

      <div className={"input-cont"}>
        <Input
          value={name}
          onChange={(ev) => setName(ev.target.value)}
          size={"large"}
          placeholder={"Enter a folder name"}
        />
      </div>

      <footer>
        <Button size={"large"} onClick={() => onClose([])}>
          Cancel
        </Button>
        <Button
          size={"large"}
          className={"primary"}
          onClick={save}
          loading={saving}
          disabled={!name}
        >
          Create
        </Button>
      </footer>
    </div>
  );
}
